import { Col, Container, Row } from "react-bootstrap"
import { fadeIn, fadeInBlur } from "../../Functions/GlobalAnimations"
import { m } from "framer-motion"
import ProcessStep from "../../Components/ProcessStep/ProcessStep"
import { ourMission, keyComponents } from "../../Components/ProcessStep/ProcessStepData"
import { Swiper, SwiperSlide } from "swiper/react";
import Lists from '../../Components/Lists/Lists'

import { Autoplay, Navigation } from "swiper/modules";

const About = () => {
    const TestimonialsCarouselData = ['/images/IMG-20250711-WA0005.webp','/images/WhatsApp Image 2025-07-30 at 9.14.35 AM.jpeg.webp','/images/Agro Park.webp']
    return (
        <>
            <m.div className='container  mt-[200px] '>
                <Col xl={8} lg={10} className="text-center w-fit">
                    <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">About Us</h3>
                    <m.div
                        className="border-b border-1 w-[40%] border-[#146084]"
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: 1 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    />
                </Col>

                <m.div
                    {...fadeIn}
                    className="mt-[50px] bg-[#1460840a] p-[35px] rounded-br-[100px] rounded-tl-[100px]"
                >
                    <p className="text-[21px] text-justify font-light text-black tracking-[-.5px] mb-[30px] md:mb-[15px]">
                        The Kerala Climate Resilient Agri-Value Chain Modernization Project{" "}
                        <span className="font-bold">(KERA)</span> is a Government of Kerala initiative implemented in partnership with the World Bank. The project aims to transform Kerala’s agricultural landscape by strengthening climate resilience, enhancing value chains, and improving farmers’ livelihoods through sustainable, inclusive, and technology-driven interventions.
                    </p>
                    <p className="text-[21px] text-justify font-light text-black tracking-[-.5px] mb-[30px] md:mb-[15px]">
                        Conceived in the wake of increasing climate uncertainties and the need for market-oriented agricultural development,{" "}
                        <span className="font-bold">KERA</span> focuses on building an ecosystem where farmers, producer companies, agribusinesses, research institutions, and public agencies work collaboratively to achieve long-term resilience and competitiveness in agriculture.
                    </p>
                </m.div>
            </m.div >

            <m.section className="relative mt-[100px]" {...fadeIn}>
                <div style={{ backgroundImage: "url('./images/2b_2_11zon.webp')" }} className="mxl:bg-cover py-[100px] lg:py-[90px] w-full bg-cover md:py-[75px] sm:py-[50px] sm:px-[15px] bg-fixed lg:bg-cover lg:bg-local lg:bg-center">
                    <div className="left-0 top-0 h-full w-full absolute bg-darkslateblue opacity-50"></div>
                    <Container className="relative">
                        <Row className="justify-center items-center">
                            <Col xl={12} md={8} sm={10} className="md:mb-[30px] sm:mb-[30px]">
                                <Col xl={8} lg={10} className="text-center w-fit">
                                    <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-white -tracking-[1px]">Our Vision</h3>
                                    <m.div
                                        className="border-b border-1 w-[40%] border-white"
                                        initial={{ scaleX: 0 }}
                                        animate={{ scaleX: 1 }}
                                        transition={{ duration: 0.5, delay: 0.2 }}
                                    />
                                </Col>
                                <h2 className="heading-5 mt-[20px] text-[30px] font-serif font-semibold text-white mb-0 sm:text-center">
                                    To promote the resilience and commercialization of Kerala's food and agriculture sector.
                                </h2>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </m.section>
            <section className="py-[160px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px] overflow-hidden">
                <Container>
                    <Row className="items-center justify-center">
                        <Col xl={12} lg={12} md={9}>
                            <Col xl={8} lg={10} className="text-center w-fit mb-[20px]">
                                <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">Our Mission</h3>
                                <m.div
                                    className="border-b border-1 w-[40%] border-[#146084] "
                                    initial={{ scaleX: 0 }}
                                    animate={{ scaleX: 1 }}
                                    transition={{ duration: 0.5, delay: 0.2 }}
                                />
                            </Col>
                            <h4 className=" text-[20px] w-[60%] text-black block -tracking-[1px] mb-20 lg:text-[30px] lg:mb-[80px] md:text-[34px] md:mb-[75px] sm:text-[29px]">To modernize Kerala’s agricultural value chains and build a climate-resilient, market-ready agri-food ecosystem by</h4>
                            <ProcessStep grid="row-cols-1" theme='process-step-style-02' className="" data={ourMission} animation={fadeIn} />
                        </Col>
                    </Row>
                </Container>
            </section>

            <m.section className="py-[130px] lg:py-[90px] md:py-[75px] xs:py-[50px] bg-lightgray" {...fadeIn}>
                <Container>
                    <Col xl={8} lg={10} className="text-center w-fit mb-[20px] mb-[40px]">
                        <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">Key Components</h3>
                        <m.div
                            className="border-b border-1 w-[40%] border-[#146084] "
                            initial={{ scaleX: 0 }}
                            animate={{ scaleX: 1 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                        />
                    </Col>
                    <Row className="items-center">
                        <Col lg={6} className="p-0 md:mb-[50px] border-white border-[12px] rounded-lg shadow-[0_0_15px_rgba(0,0,0,0.1)]">
                            <div className="relative">
                                <Swiper
                                    className="white-move swiper-pagination-medium h-full swiper-navigation-01 swiper-navigation-light"
                                    modules={[Navigation,Autoplay]}
                                    spaceBetween={30}
                                    slidesPerView={1}
                                    loop={true}
                                    autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: false,
                                    }}
                                    navigation={true}>
                                    {
                                        TestimonialsCarouselData.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i} className="h-auto">
                                                    <div className="h-full shadow-lg flex items-center bg-[#fff]">
                                                        <img src={item} alt="business" className="w-full" width="531" height="413" />
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                                </Swiper>
                            </div>
                        </Col>
                        <Col lg={{ span: 5, offset: 1 }} >
                            <p className="text-[19px] text-black ">The KERA Project is structured across multiple components that address the entire agri-value chain</p>
                            <Lists theme="list-style-02" data={keyComponents} className="mb-12 mt-8 text-darkgray font-serif" animation={fadeIn} />
                        </Col>
                    </Row>
                </Container>
            </m.section>
          
            <m.section whileInView={fadeIn.whileInView} {...fadeIn} className="py-[160px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px] ">
                <Container>
                    <Col xl={8} lg={10} className="text-center w-fit mb-[40px]">
                        <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">Our Approach</h3>
                        <m.div
                            className="border-b border-1 w-[40%] border-[#146084] "
                            initial={{ scaleX: 0 }}
                            animate={{ scaleX: 1 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                        />
                    </Col>
                    <m.p whileInView={fadeInBlur.whileInView} {...fadeInBlur} className="text-[20px] text-justify"><span className="font-bold">KERA</span> adopts a participatory, decentralized, and multi-stakeholder approach to agricultural transformation. All interventions are designed to be demand-driven and context-specific, ensuring they respond to the unique needs of Kerala’s diverse agri-climatic zones.
                        <br />
                        <br />
                        While the project is anchored in the Department of Agriculture Development and Farmers’ Welfare, it is implemented in close collaboration with a range of government departments,agencies, and institutions. These include the Department of Industries, Kerala Industrial Infrastructure Development Corporation (KINFRA), Kerala Agricultural University (KAU), Kerala Startup Mission (KSUM), and other technical and research organizations.
                        <br />
                        <br />
                        Through this integrated approach, <span className="font-bold">KERA</span>  aims to bring convergence, innovation, and efficiency across the agricultural value chain, from production to market, while fostering climate resilience and inclusive growth.
                    </m.p>
                </Container>
            </m.section>

        </>
    )
}

export default About